import React from "react";

const Footer = () => {
  return (
    <div className="w-full flex justify-center items-center bottom-2 shadow-footerShadow text-P600 bg-bgPrimary mt-4">
      <div className="flex flex-col justify-center items-center">
        <div className="font-semibold text-sm mt-2 mb-4">
          © 2022 Website. All rights reserved
        </div>
      </div>
    </div>
  );
};

export default Footer;
